// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 94 ? "pdfjsWorker" : chunkId) + "." + {"52":"1b5cbb39","94":"693dd1d0","413":"4d6d6bc6","963":"c0ee6804"}[chunkId] + ".chunk.js";
};